import * as actionTypes from '../../actions/business/actionTypes';

export const initialState = {
  businesses: [],
  isLoading: true
};

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_BUSINESSES:
      return {
        ...state,
        isLoading: false,
        businesses: action.data
      };
    case actionTypes.SET_BUSINESSES_LOADING:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default businessReducer;
